import Vue from "vue";
import VueRouter from "vue-router";
import { default as AutoClaim } from "./modules/auto-claim/autoClaimRouter.js";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [...AutoClaim],
});

// router.beforeEach(async (to, from, next) => {
//     try {
//         next();
//     } catch (e) {
//         next(e);
//     }
// })
//
//
// router.onError((error) => {
//   debugger;
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     window.reload(true);
//   }
// });

export { router };
